<div *ngIf="isLoading">
    <div class="spinner-border loader" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
    <div id="overlay" class="overlay"></div>
</div>